import angular from 'angular';

import RwAppVersionComponent from './rw-app-version-component';
import { RwAppVersionController } from './rw-app-version-controller';

export default angular
  .module('rw-app-version', [])
  .controller('RwAppVersionController', RwAppVersionController)
  .component('rwAppVersion', RwAppVersionComponent);



// WEBPACK FOOTER //
// ./src/modules/utils/rw-app-version/rw-app-version-module.js